<template>
  <div class="wrapper">
    <p class="mb-1 font-size--14 font-weight-black">{{ $moment(item.date).format() }}</p>
    <div class="box">
      <v-layout justify-space-between>
        <span style="font-size: 0.9em;">총 수취액</span>
        <span>{{ commaFormat(totalReceived) }} 원</span>
      </v-layout>
      <div class="sub-box">
        <v-layout justify-space-between>
          <span>{{ isCollection ? '집금액' : '상환 원금' }}</span>
          <span>{{ commaFormat(item.principal) }} 원</span>
        </v-layout>
        <v-layout justify-space-between>
          <span>대출 이자</span>
          <span>{{ commaFormat(item.interest) }} 원</span>
        </v-layout>
        <v-layout justify-space-between>
          <span>플랫폼 수수료</span>
          <span>{{ commaFormat(item.fee) }} 원</span>
        </v-layout>
      </div>
      <v-layout justify-space-between>
        <span style="font-weight: bold;">{{ isCollection ? '집금 잔액' : '대출 잔액' }}
          <span style="font-size: 0.7em; margin-left: 4px; color: #666;">
            (이전 잔액 - {{ isCollection ? '집금액' : '상환 원금' }})
          </span>
        </span>
        <span>{{ commaFormat(item.loanBalance) }} 원</span>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { commaFormat } from '@/filter/number'

export default {
  props: ['item', 'isCollection'],
  methods: {
    commaFormat,
  },
  computed: {
    totalReceived() {
      return this.item.principal + this.item.interest + this.item.fee;
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .box {
    background-color: #eee;
    padding: 16px;
    border-radius: 8px;
    font-weight: bold;

    .sub-box {
      background-color: #fafafa;
      padding: 12px;
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 12px;
    }
  }

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
}
</style>
